import React from "react";

function useToggle(initialValue = false): [boolean, () => void] {
	const [value, setValue] = React.useState(initialValue);
	const toggleFn = React.useCallback(() => {
		setValue(v => !v);
	}, [setValue]);
	return [value, toggleFn];
}

export default useToggle;
